import type { AGENCY_VIEW, APP_VIEW, ORG_VIEW } from '../../../common/support/viewConstants';

declare global {
  interface Window {
    API_BASE?: string;
    branch?: any;
    App: {
      context: {
        environment: string;
        flipper: {
          [flag: string]: boolean;
        };
        ppp: {
          [flag: string]: boolean;
        };
        userId?: string;
        pendoId?: string;
        codeVersion?: string;
        tracesSampleRate?: number;
        errorSampleRate?: number;
        sentryAlertNotificationsId?: string;
        sentryJourneysCreativesOptimizationId?: string;
        sentryPostbacksFormId?: string;
        sentryQrCodeCustomizationsId?: string;
        sentryQuickLinkTemplatesId?: string;
        sentryUsageId?: string;
        sentryDiscoDashboardId?: string;
        learnMoreLinks: {
          [key: string]: string;
        };
        cakeUrl: string;
        view: {
          app_id?: string;
          current_view?: typeof APP_VIEW | typeof AGENCY_VIEW | typeof ORG_VIEW;
          organization_id?: string;
          ownerEmail?: string;
        };
      };
    };
  }
}

export class FlipperService {
  constructor(private flipper) {}

  static getInstance() {
    return new FlipperService(window.App.context.flipper);
  }

  isActive(flag: string) {
    return this.flipper[flag];
  }
}
